import styled from 'styled-components';

export const WrapperStyled = styled.div`
  position: absolute;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90vw;
  max-width: 750px;
  background-color: #fff;
  padding: 40px 0;
  border-radius: 15px;
  outline: none;
`;

export const ContentStyled = styled.div`
  padding: 0 30px;
  max-height: calc(90vh - 210px);
  overflow-y: scroll;

  h6 {
    font-size: 18px;
    color: #2863d0;
    margin: 0;
  }

  p,
  li {
    font-size: 16px;
    line-height: 23px;
  }

  table {
    font-size: 14px;
    margin: 16px 0;
    width: 100%;
    border-collapse: collapse;
    th,
    td {
      border: 1px solid #ddd;
      padding: 8px;
    }
    th {
      background-color: #ddd;
    }
  }

`;

export const ButtonWrapperStyled = styled.div`
  display: flex;
  justify-content: center;

  button {
    max-width: 250px;
    margin: 30px auto 0 auto;
  }
`;

export const PolicyTitle = styled.h2`
  margin: 24px 0;
  font-size: 28px;
  color: #2863d0;
  padding: 0 30px;
`;

export const PolicySubtitle = styled.h3`
  margin: 24px 0 16px 0;
  color: #2863d0;
`;
